import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Floating shortcut visible in the bottom-left corner on every page
 * whenever the signed-in user has role='admin'. Hidden on the /admin
 * page itself to avoid noise.
 */
const AdminShortcut = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!user || user.role !== "admin") return null;
  if (pathname.startsWith("/admin")) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="fixed z-40 bottom-5 left-5 sm:bottom-6 sm:left-6"
    >
      <Link
        to="/admin"
        data-testid="admin-shortcut-link"
        title="Open admin dashboard"
        className="group inline-flex items-center gap-2 pl-3 pr-5 py-3 rounded-full bg-[#003566] text-white hover:bg-[#002244] shadow-lg hover:shadow-xl transition-all active:scale-95"
      >
        <span className="w-8 h-8 rounded-full bg-white/15 group-hover:bg-white/25 flex items-center justify-center transition-colors">
          <ShieldCheck className="w-4 h-4" strokeWidth={2} />
        </span>
        <span className="text-sm font-semibold whitespace-nowrap">Admin</span>
      </Link>
    </motion.div>
  );
};

export default AdminShortcut;
